import coinFeatureData from './coinFeatureData';
const categoriesSet = new Set();
coinFeatureData.forEach((item) => {
    categoriesSet.add(item.category);
});
const coinFeatureCategories = Array.from(categoriesSet);
export default coinFeatureCategories;
